<template>
  <v-dialog width="400px" v-model="dialog" persistent>
    <v-card>
      <v-card-title>
        <div class="d-flex justify-space-between" :style="{ width: '100%' }">
          <div>{{ 'Xác nhận nạp xu' }}</div>
          <v-icon @click="() => closeDialog()">mdi-close</v-icon>
        </div>
      </v-card-title>
      <v-divider class="mb-3" />
      <v-card-text>
        <div class="d-flex justify-space-between mb-2">
          <CardStudentName :student="student" />
        </div>
        <div>
          <v-text-field
            :rules="[$rules.isNumber]"
            hasAppend
            outlined
            dense
            class="text-body-2"
            placeholder="Nhập số tiền nạp thêm"
            :value="data.amount"
            @input="handlerInputNumber"
            hide-details
          >
            <template #label>
              <span>{{ 'Số tiền nạp thêm' }}<strong class="red--text ml-1">* </strong></span>
            </template>
            <template slot="append">
              <div>{{ 'VND' }}</div>
            </template>
          </v-text-field>
        </div>
      </v-card-text>
      <v-divider />
      <v-card-actions class="mx-2">
        <v-btn color="error" @click="() => closeDialog()" class="my-1" outlined>Huỷ</v-btn>
        <v-spacer />
        <v-btn depressed color="primary" @click="() => requestRecharge()">Xác nhận</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import CardStudentName from '@/components/basic/card/CardStudentName.vue'
import { get } from 'lodash'
import { mapActions } from 'vuex'
export default {
  components: { CardStudentName },
  data() {
    return {
      dialog: false,
      student: {},
      creditId: null,
      get,
      data: {
        amount: null
      }
    }
  },
  methods: {
    ...mapActions({
      requestCharge: 'studentCredit/requestCharge',
      onChangeAmount: 'studentCredit/onChangeAmount'
    }),
    openDialog(studentData = {}) {
      if (studentData && studentData.id) {
        this.student = studentData.student
        this.creditId = studentData.id
        this.dialog = true
      }
    },
    closeDialog() {
      this.dialog = false
      this.student = {}
      this.creditId = null
    },
    handlerInputNumber(value) {
      this.data.amount = this.formatMoney(value)
    },
    formatMoney(value) {
      let formatPrice = ''
      if (typeof value === 'string' && value.length) {
        let rawData = value.split(',').join('')
        if (isNaN(Number(rawData))) {
          formatPrice = rawData
        } else {
          formatPrice = Number(rawData).toLocaleString('en-US')
        }
      }
      return formatPrice
    },
    async requestRecharge() {
      this.$loading.active = true
      try {
        const moneyToNumber = Number(
          this.data.amount
            .split('')
            .filter(v => v !== ',')
            .join('')
        )
        if (typeof moneyToNumber === 'number' && !isNaN(moneyToNumber)) {
          await this.requestCharge({ amount: moneyToNumber, studentId: this.student.id })
          this.onChangeAmount({ id: this.creditId, amount: moneyToNumber })
          this.$alert.success('Nạp xu thành công')
          return this.closeDialog()
        }
      } catch (error) {
        this.$alert.error('Có lỗi xảy ra trong quá trình nạp')
      } finally {
        this.$loading.active = false
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
